import emailjs from "emailjs-com";
import { useRef } from "react";
import {
  useGsapGalleryImg,
  useGsapGalleryTitle,
  useGsapGalleryCategory,
} from "./Hooks/gsap";
import './About.css'
import contactImage from '../assets/Contact.jpg';
import Headers from '../components/Headers'
import toast from 'react-hot-toast';

const ContactUs = ({ src, title, category }) => {
  const galleryImg = useRef(null);
  const galleryTitle = useRef(null);
  const galleryCategory = useRef(null);
  const formRef = useRef(null);


  useGsapGalleryImg(galleryImg);
  useGsapGalleryTitle(galleryTitle, galleryImg);
  useGsapGalleryCategory(galleryCategory, galleryImg);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_raeorwo', 'template_47299sc', formRef.current, 'yhpNahO4KUZ5u9Mp_')
      .then((result) => {
        console.log(result.text);
        toast.success('Your message has been sent successfully!');
      }, (error) => {
        console.log(error.text);
        toast.error('There was an error sending your message.');
      });

    // Clear the form fields after submission if needed
    formRef.current.reset();
  }

  return (
    <div className="gallery-item">
      <h1 className="gallery-item-title" ref={galleryTitle}>
        Contact Us
      </h1>
      <div className="gallery-item-title" ref={galleryTitle}>
      <form  ref={formRef} onSubmit={sendEmail} className="mt-[35%] w-[450px] ">
          <div>
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email</label>
              <input type="email" id="email" name="email" className="shadow-sm  mb-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="name@gmail.com" required/>
          </div>
          <div>
              <label htmlFor="subject" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Subject</label>
              <input type="text" id="subject" name="subject" className="block p-3 mb-3 w-full text-sm text-gray-900 bg-gray-50  border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light" placeholder="Let us know how we can help you" required/>
          </div>
          <div className="sm:col-span-3">
              <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your message</label>
              <textarea id="message" name="message" rows="5" className="block  p-2.5 w-full text-sm text-gray-900 bg-gray-50  shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Leave a comment..."></textarea>
          </div>
          <button type="submit" className="px-4 w-50 h-[10vh] py-2 text-lg bg-blue-700 hover:bg-blue-800">Send message</button>
      </form>
      </div>
      <p className="gallery-item-category" ref={galleryCategory}>
        {category}
      </p>
      <div
        ref={galleryImg}
        style={{ backgroundImage: `url(${contactImage})`  }}
        className="gallery-item-image"
      ></div>
    </div>
  );
};

const images = [
  {
    id: 1,
    src:'',
    category: "Get in touch with us",
  },
];

const Gallery = () => {
  return (
    <>
    <Headers/>
  
      <div className="gallery-wrapper">
        {images.map((image) => (
          <ContactUs key={image.id} {...image} />
        ))}
      </div>
    </>
  );
};

export default Gallery;